//Product weight add
const newRadio = document.querySelectorAll('.new_variant_pill input');
const prodWeight = document.querySelector('.prod_weight_name');

if (prodWeight) {
    function handleRadioClick(event) {
        const clickedRadio = event.target;
        const dataValue = clickedRadio.getAttribute('data-variant-id-name');
        prodWeight.innerHTML = dataValue;    
    }
    
    newRadio.forEach(radio => {
        radio.addEventListener('click', handleRadioClick);
        if (radio.checked) {
            const dataValue = radio.getAttribute('data-variant-id-name');
            prodWeight.innerHTML = dataValue;    
        }
    }); 
}

//Add to Cart btn Simulation Only 
// document.addEventListener("click", function(event) {
//     if (event.target.classList.contains("ATC_button")) {
//         var elm = event.target;
//         var commonParent = elm.closest('.product_new_style');
//         var submitButton = commonParent.querySelector(".product-form__buttons button.product-form__submit");

//         if (submitButton) {
//             submitButton.click();
//         }
//     }
// });
document.addEventListener("click", function(event) {    
    
    if (event.target.classList.contains("ATC_button") && event.target.classList.contains("quick-add__submit")) {
        
        let elm = event.target;
        let commonParent = elm.closest('.form');
        // let submitButton = commonParent.querySelector(".product-form__buttons button.product-form__submit");
        var custText = commonParent?.querySelector(".custom-text");
        var docName = commonParent?.querySelector(".doc-name");

        if (custText) {
            custText.value = '';
    
            // custText.value = "";
        }

        if(custText && custText.value.trim() == ""){

            event.preventDefault();
            let upPresc = document.getElementById('upload-prescription');
            let custLocation = custText.id;
            let docLocation = docName.id;

            upPresc?.querySelector('#custom-text-location').setAttribute('value',custLocation);
            upPresc?.querySelector('#doc-name-location').setAttribute('value',docLocation);
            // upPresc.style.display = 'flex';
            let productUrl = elm.getAttribute('data-product-url');            
            window.location.href = productUrl;
        }else{
            // console.log(123456);
            // submitButton.click();
        }

    } else if (event.target.classList.contains("ATC_button")) {
        console.log('-------......');
        
        var elm = event.target;
        var commonParent = elm.closest('.product_new_style');
        var submitButton = commonParent.querySelector(".product-form__buttons button.product-form__submit");
        var custText = commonParent.querySelector(".product-form form .custom-text");
        var docName = commonParent.querySelector(".product-form form .doc-name");

        if(custText){
            let upPresc = document.getElementById('upload-prescription');
            let custLocation = custText.id;
            let docLocation = docName.id;

            upPresc.querySelector('#custom-text-location').setAttribute('value',custLocation);
            upPresc.querySelector('#doc-name-location').setAttribute('value',docLocation);
            upPresc.style.display = 'flex';
        }else{
            submitButton.click();
        }
    } else{ 

    }
});

var pincodeList = {
    "Pincodes": [
        410206, 410222, 400704, 400612, 400702, 410221, 410208, 400707, 400708, 203125, 400701, 410210, 400710, 410218, 410220, 400709, 400703, 400705, 400614, 400706, 400001, 400002, 400003, 400004, 400005, 400006, 400007, 400008, 400009, 400010, 400011, 400012, 400013, 400014, 400015, 400016, 400017, 400018, 400019, 400020, 400021, 400022, 400024, 400025, 400026, 400027, 400028, 400029, 400030, 400031, 400032, 400033, 400034, 400035, 400037, 400042, 400043, 400049, 400050, 400051, 400052, 400053, 400054, 400055, 400056, 400057, 400058, 400059, 400060, 400061, 400063, 400064, 400065, 400066, 400067, 400068, 400069, 400070, 400071, 400072, 400074, 400075, 400076, 400077, 400078, 400079, 400080, 400081, 400082, 400083, 400084, 400085, 400086, 400087, 400088, 400089, 400091, 400092, 400093, 400094, 400095, 400096, 400097, 400098, 400099, 400101, 400102, 400103, 400104, 400608, 400605, 400601, 400607, 400610, 400606, 400603, 400602, 400604
    ]
};

function checkPincode() {

    var inputElement = document.getElementById('c_av--pincode');
    var badgeElement = document.getElementById('c_av--badge');
    var badgeTextElement = document.getElementById('c_av--badge_text');

    var LabelBadgeElement = document.getElementById('c_av--badge-label');
    var LabelBadgeTextElement = document.getElementById('c_av--badge_text-label');
    var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    // console.log(screenWidth);

    // Reset styles
    badgeElement.style.display = 'none';
    badgeTextElement.textContent = '';

    // Check if input is a 6-digit code
    var enteredPincode = parseInt(inputElement.value);
    if (isNaN(enteredPincode) || enteredPincode.toString().length !== 6) {
        return;
    }
    
    // Check if the entered pincode is in the list
    if( screenWidth < 1440){
        badgeElement.style.display = 'none';
        if (pincodeList.Pincodes.includes(enteredPincode)) {
            LabelBadgeElement.style.display = 'flex';
            LabelBadgeTextElement.textContent = 'Same Day Delivery!';
        } else {
            LabelBadgeElement.style.display = 'flex';
            LabelBadgeTextElement.textContent = 'Rapid 3-4 Day Delivery,Tiny Extra Fee!';
        }
    }else{
        LabelBadgeElement.style.display = 'none';
        if (pincodeList.Pincodes.includes(enteredPincode)) {
            badgeElement.style.display = 'flex';
            badgeTextElement.textContent = 'Same Day Delivery!';
        } else {
            badgeElement.style.display = 'flex';
            badgeTextElement.textContent = 'Rapid 3-4 Day Delivery,Tiny Extra Fee!';
        }
    }
}

//Disable Select tag of facets of mobile in desktop
function checkScreenSize(formElm) {
    var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var formElements = document.querySelectorAll(formElm);

    formElements.forEach(function(selectElement) {
        var options = selectElement.options;

        for (var i = 0; i < options.length; i++) {
            if (screenWidth >= 767) {
                // Disable the option element
                options[i].setAttribute('disabled', 'disabled');
                // console.log(`${formElm} option ${i + 1} disabled`);
            } else {
                // Enable the option element
                options[i].removeAttribute('disabled');
                // console.log(`${formElm} option ${i + 1} enabled`);
            }
        }
    });
}

// Add an event listener for window resize
window.addEventListener('resize', () =>{
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(function() {
        checkScreenSize('#custom__sorting-mobile #FacetFiltersForm select')
    }, 200);

    let badgeElement = document.getElementById('c_av--badge');
    let LabelBadgeElement = document.getElementById('c_av--badge-label');
    if( LabelBadgeElement || badgeElement){
        LabelBadgeElement.style.display = 'none';
        badgeElement.style.display = 'none';
    }

});

// Trigger the event on page load
window.addEventListener('load', checkScreenSize('#custom__sorting-mobile #FacetFiltersForm select'));

// Cart Remove show on click on Minus when value on 1
document.addEventListener('click', (e) => {
    if(e.target.classList.contains('quantity__button') && e.target.getAttribute('name') == 'minus'){
      
        // console.log(e.target);                       

        let nxtElm = e.target.closest('.cart-quantity').querySelector('.quantity__input');
        // console.log(nxtElm.dataset.cartQuantity);
        if( nxtElm ){
            let inputValue = nxtElm.getAttribute('value');
            
            if(inputValue == 1 || nxtElm.dataset.cartQuantity == inputValue){
                e.target.closest('.quantity-popover-wrapper').querySelector('cart-remove-button').style.display = 'flex';
                e.target.closest('.cart-item__wrapper').style.width = '83%';
            }else{
                e.target.closest('.quantity-popover-wrapper').querySelector('cart-remove-button').style.display = 'none';
                e.target.closest('.cart-item__wrapper').style.width = '100%';
            }
        }
    }
})


// Prescription Popup
let custPrescPopup = document.querySelector('#custom_upload-prescription');
let custPrescOpenbtn = document.querySelector('.upload__prescription_btn');
if (custPrescOpenbtn) {
    custPrescOpenbtn.addEventListener('click', function(e) {
        e.preventDefault();
        custPrescPopup.style.display = "flex";
        // console.log(custPrescOpenbtn);
        // console.log(custPrescPopup);

        // Get the selected images
        // let selectedFile;
        // document.querySelector('#presc-img-upload').addEventListener('change', function() {
        //     if (this.files.length > 0) {
        //         // console.log(file.files)
        //         console.log(this.value);
        //         selectedFile = this.value;
        //         // console.log(file.files[0])
        //     }
        // });
        
        // document.querySelector('#custom_up-presc--upload_btn').addEventListener('click', function(evt) {
        //     // console.log("Btn Clicked");
        //     //   evt.preventDefault();
        //   let custDocName = document.querySelector('#cut_doc-name').value;
        //     //   console.log(selectedFile);
        //     //   console.log(custDocName);
        
        //     //   let dataUpload = {
        //     //     "Prescription" : selectedFile,
        //     //     "Doctor" : custDocName
        //     //   };
        //     //   console.log(JSON.stringify(dataUpload));
        
        //     //   fetch('', {
        //     //     method: "POST",
        //     //     body: JSON.stringify(dataUpload),
        //     //     headers: {
        //     //         "Content-Type": "application/json"
        //     //     }
        //     //   })
        //     //   .then(response => {
        //     //     return response.json()
        //     //   })
        //     //   .then(data => {
        //     //     console.log(data)
        //     //   })
        //     //   .catch(error => {
        //     //     console.error(error)
        //     //   });
        //     // Reference to your file input element
        //     // const fileInput = document.getElementById('presc-img-upload');
        //     const fileInput = document.querySelector('.up-presc__output-img');
        
        //     // Example JSON data
        //     const postData = {
        //         text_input: custDocName
        //     };
        
        //     // Create a FormData object
        //     const formData = new FormData();
        
        //     // Append the file and other data to the FormData object
        //     formData.append('Prescription', fileInput.files[0]);
        //     formData.append('Doctor', postData.text_input);
        
        //     // // URL of your API endpoint
        //     console.log("Hello");
        //     console.log(formData);
        //     // const apiUrl = "";
        //     // // Making a POST request with Fetch API
        //     // fetch(apiUrl, {
        //     //     method: "POST",
        //     //     body: formData,
        //     // })
        //     // .then(response => response.json())
        //     // .then(data => {
        //     //     console.log("Response from server:", data);
        //     //     // Handle the response from the server
        //     // })
        //     // .catch(error => {
        //     //     console.error("Error:", error);
        //     //     // Handle errors
        //     // });
        // });
    
    
    })
}

if (document.querySelector('.formUploadPrescription')) {
    document.querySelector('.formUploadPrescription').addEventListener('submit', function(evt) {
        evt.preventDefault();
        var formData = new FormData();
        formData.append('prescription_img', document.getElementById('cust_presc-img-upload').files[0]);
        formData.append('cust_doc_name', document.getElementById('cust_doc-name').value);
        // formData.append('prescription_img', prescription_img);
        // $.ajax({
        //     url: 'https://shopify.animeal.in/shopify-apis/ani_upload.php',
        //     type: 'POST',
        //     data: formData,
        //     contentType: false,
        //     processData: false,
        //     success: function(response) {
        //         console.log(response);
        //         console.log("Success");
        //     },
        //     error: function(error) {
        //         console.log(this);
        //         console.error('Error uploading file', error);
        //     }
        // });
    
        var requestAjax = new XMLHttpRequest();
        requestAjax.open("POST", "https://nodejs.animeal.in/api/animeal-upload", true);
        // requestAjax.setRequestHeader("Content-Type", false);
        requestAjax.processData = false;
        requestAjax.onreadystatechange = function() { 
            // console.log(this.readyState , this.status);
            if (this.readyState == 4 && this.status == 200) {
                document.querySelector('.custom_upload-prescription-section .up-presc_submitted').style.setProperty('display', 'block', 'important');
                setTimeout(()=>{
                    document.querySelector('.custom_upload-prescription-section .up-presc_submitted').style.setProperty('display', 'none', 'important');
                    document.querySelector('.custom_upload-prescription-section#custom_upload-prescription').style.display = "none";
                },3000);
                // Typical action to be performed when the document is ready:
                // document.getElementById("demo").innerHTML = requestAjax.responseText;
            }
        };
        requestAjax.send(formData);
    });
}

// document.querySelector('#custom_up-presc--upload_btn').addEventListener('click', function(evt))

// document.querySelector('#custom_up-presc--upload_btn').addEventListener('click', function(evt) {
//     //   evt.preventDefault();
//     //   let docName = document.querySelector('#cut_doc-name').value;
//     //   console.log(selectedFile);
//     //   console.log(docName);

//     //   let dataUpload = {
//     //     "Prescription" : selectedFile,
//     //     "Doctor" : docName
//     //   };
//     //   console.log(JSON.stringify(dataUpload));

//     //   fetch('', {
//     //     method: "POST",
//     //     body: JSON.stringify(dataUpload),
//     //     headers: {
//     //         "Content-Type": "application/json"
//     //     }
//     //   })
//     //   .then(response => {
//     //     return response.json()
//     //   })
//     //   .then(data => {
//     //     console.log(data)
//     //   })
//     //   .catch(error => {
//     //     console.error(error)
//     //   });
//     // Reference to your file input element
//     // const fileInput = document.getElementById('presc-img-upload');
//     // const fileInput = document.querySelector('.up-presc__output-img img').src;

//     // Example JSON data
//     // const postData = {
//     //     text_input: docName
//     // };

//     // Create a FormData object
//     // const formData = new FormData();

//     // Append the file and other data to the FormData object
//     // formData.append('Prescription', fileInput.files[0]);
//     // formData.append('Doctor', postData.text_input);

//     // // URL of your API endpoint
//     // console.log("Hello");
//     // console.log(formData);
//     // const apiUrl = "";
//     // // Making a POST request with Fetch API
//     // fetch(apiUrl, {
//     //     method: "POST",
//     //     body: formData,
//     // })
//     // .then(response => response.json())
//     // .then(data => {
//     //     console.log("Response from server:", data);
//     //     // Handle the response from the server
//     // })
//     // .catch(error => {
//     //     console.error("Error:", error);
//     //     // Handle errors
//     // });

// });


// Prescription Popup will only show on Product Page

const prescBtn = document.getElementById('prescription_popup_btn');
const prescPopup = document.getElementById('prescription_popup');

if( prescBtn && prescPopup){
    prescBtn.addEventListener('click', () => {
        prescPopup.style.display = 'flex';
    })
    prescPopup.querySelector('.presc-close-icon').addEventListener('click', () => {
        prescPopup.style.display = 'none';
    })
    prescPopup.querySelector('.prescription-btn').addEventListener('click', () => {
        prescPopup.style.display = 'none';
    })
    prescPopup.addEventListener('click', (e) => {
        if (!prescPopup.querySelector('.prescription-container').contains(e.target)) {
            prescPopup.style.display = 'none';
        }
    })
}


//Upload Prescription
const prescOutput = document.getElementById('presc-img-output');
const prescInput = document.getElementById("presc-img-upload");
const prescInput1 = document.getElementById("cust_presc-img-upload");
const prescInput2 = document.getElementById("presc-img-upload-sec");

let imagesArray = [];
let cust_imagesArray = [];

function deleteImage(index, p) {
    imagesArray.splice(index, 1)
    if(p === 'first') {
        if (prescInput) {
            prescInput.value = '';
        }
    }else {
        if (prescInput2) {
            prescInput2.value = '';
        }
    }

    displayPrescImages();

    if(!imagesArray.length > 0){
        const curP = p === 'first' ? prescInput : prescInput2;
        toggleUploadElm( curP, true )
    }  
}

function displayPrescImages(p) {
    let images = "";
    imagesArray.forEach((image, index) => {
        images += `<div class="up-presc__output-img">
                        <img src="${URL.createObjectURL(image)}" alt="image">
                        <span class="up-presc__op-remove" onclick="deleteImage(${index}, '${p}')">&times;</span>
                    </div>`;
    })
    prescOutput.innerHTML = images
}
if (prescInput) {
    prescInput.addEventListener("change", () => {
        const files = prescInput.files;
        for (let i = 0; i < files.length; i++) {
            // imagesArray.push(files[i])
            imagesArray[0] = files[i];
            document.querySelector('.upload-prescription-err-mssg')?.classList?.add('hidden')
        }
        displayPrescImages('first');
        toggleUploadElm(prescInput);
    }) 
}
if (prescInput1) {
    prescInput1.addEventListener("change", () => {
        const files = prescInput1.files;
        for (let i = 0; i < files.length; i++) {
            cust_imagesArray[0] = files[i];
        }
        
        cust_displayPrescImages();
        toggleUploadElm(prescInput1);
    }) 
}

if (prescInput2) {
    prescInput2.addEventListener("change", () => {
        const files = prescInput2.files;
        for (let i = 0; i < files.length; i++) {
            // cust_imagesArray.push(files[i])
            imagesArray[0] = files[i];
        }
        
        displayPrescImages('sec');
        toggleUploadElm(prescInput2);
    }) 
}


function toggleUploadElm(fileInpElm, toggleOnDelete){
    let form, formDiv, formDiv2;
    if(fileInpElm.id === 'presc-img-upload'){
        formDiv = fileInpElm.closest('.up-presc--form');
    } else if (fileInpElm.id === 'presc-img-upload-sec') {
        formDiv2 = fileInpElm.closest('.up-presc--form');
    } else{
        form = fileInpElm.closest('form');
    }
    if(form){
            form.querySelector('#custom_upload_choose_file').style.display = toggleOnDelete ? "block" : "none";
            form.querySelector('#custom_up-presc--upload_btn').style.display = toggleOnDelete ? "none" : "block";
            return;
    }
    if(formDiv){
            formDiv.querySelector('#upload_choose_file').style.display = toggleOnDelete ? "block" : "none";
            formDiv.querySelector('#up-presc--upload_btn').style.display = toggleOnDelete ? "none" : "block";
            return;
    }
    if(formDiv2){
            formDiv2.querySelector('#upload_choose_file-sec').style.display = toggleOnDelete ? "block" : "none";
            formDiv2.querySelector('#up-presc--upload_btn-sec').style.display = toggleOnDelete ? "none" : "block";
            return;
    }
}


const cust_prescOutput = document.querySelector('.custom_upload-prescription-section #presc-img-output');
function cust_deleteImage(index) {
    cust_imagesArray.splice(index, 1)
    if (prescInput1) {
        prescInput1.value = '';
    }
    cust_displayPrescImages();
    if( !cust_imagesArray.length > 0 ){
        toggleUploadElm( prescInput1, true )
    }
}
function cust_displayPrescImages() {
    let images = "";
    cust_imagesArray.forEach((image, index) => {
        images += `<div class="up-presc__output-img">
                        <img src="${URL.createObjectURL(image)}" alt="image-${index}">
                        <span class="up-presc__op-remove" onclick="cust_deleteImage(${index})">&times;</span>
                    </div>`;
    })
    cust_prescOutput.innerHTML = images
}
if (document.querySelector('#cust_presc-img-upload')) {
    document.querySelector('#cust_presc-img-upload').addEventListener('blur', function() {
        if (this.files.length < 1) {
            document.querySelectorAll('.up-presc__op-remove').forEach((imgCloseBtn)=>{
                imgCloseBtn.dispatchEvent(new Event('click'));
            });
        }
    });
}
 
document.getElementById('upload-prescription')?.addEventListener('click', (e) => {
    if (!document.getElementById('upload-prescription').querySelector('.upload-prescription-container').contains(e.target)) {
        console.log('upload prescrkpo d none...')
        document.getElementById('upload-prescription').style.display = 'none';
    }
}) 
document.getElementById('custom_upload-prescription').addEventListener('click', (e) => {
    if (!document.getElementById('custom_upload-prescription').querySelector('.upload-prescription-container').contains(e.target)) {
        document.getElementById('custom_upload-prescription').style.display = 'none';
    }
}) 

const uploadPrescBtn = document.getElementById('up-presc--upload_btn');
if (uploadPrescBtn) {
    uploadPrescBtn.addEventListener('click', (e) => {
        let commonParent = e.target.closest('.up-presc--form');
        let prescImgUpload = commonParent.querySelector('#presc-img-upload');        
        
        let src = commonParent.querySelector('#presc-img-output img').getAttribute('src');
        let doc = commonParent.querySelector('#doc-name').value;
        // console.log(src);
    
        let custLocationId = commonParent.querySelector('#custom-text-location').getAttribute('value');
        let docLocationId = commonParent.querySelector('#doc-name-location').getAttribute('value');
        
        let customText = document.getElementById(custLocationId);
        
        customText.prepend(prescImgUpload);
    
        let docName = document.getElementById(docLocationId);
        docName.setAttribute('value',doc);

    
        let upPresc = document.getElementById('upload-prescription');
        upPresc.style.display = 'none';
    
    
        var submitButtonPrdPage = customText.closest('form').querySelector(" button.product-form__submit");
        var submitButtonPrdCard = customText.closest('form').querySelector(" button.quick-add__submit");
        
        console.log(submitButtonPrdCard, submitButtonPrdPage);
        
        if(submitButtonPrdPage){
            
            submitButtonPrdPage.click();
            // return;
            // customText.setAttribute('value', "");
            // docName.setAttribute('value',"");
        }else{
            
            submitButtonPrdCard.click();
            // console.log(submitButtonPrdCard);
            customText.setAttribute('value', "");
            docName.setAttribute('value',"");
        }
    
    
    })
}

const callMePrescBtn = document.getElementById('up-presc--call_later');
callMePrescBtn.addEventListener('click', (e) => {
    
    let commonParent = e.target.closest('.up-presc--form');
    // let src = commonParent.querySelector('#presc-img-output img').getAttribute('src');
    // let doc = commonParent.querySelector('#doc-name').value;
    // console.log(commonParent);

    let custLocationId = commonParent.querySelector('#custom-text-location').getAttribute('value');
    // let docLocationId = commonParent.querySelector('#doc-name-location').getAttribute('value');
    // console.log(custLocationId);

    let customText = document.getElementById(custLocationId);
    customText.setAttribute('value','on Call');
 
    // console.log(doc);

    // let docName = document.getElementById(docLocationId);
    // docName.setAttribute('value',doc);

    let upPresc = document.getElementById('upload-prescription');
    upPresc.style.display = 'none';
    // console.log(upPresc);

    var submitButtonPrdPage = customText.closest('form').querySelector(" button.product-form__submit");
    var submitButtonPrdCard = customText.closest('form').querySelector(" button.quick-add__submit");

    let myDivHere = customText.closest('form').querySelector(".custom-buy-btns");
    let qtyToAdd = myDivHere?.getAttribute('qty_to_add');
    if(qtyToAdd){
        let qtyOfPack = qtyToAdd.match(/\d+/)[0];
      if(qtyOfPack){
        const hiddenInputQuantity = myDivHere.querySelector('input[type="hidden"][name="quantity"]');
        
        if (hiddenInputQuantity) {
            hiddenInputQuantity.value = qtyOfPack;
        } else {
            console.log("Input not found.");
        }
      }
    }

    
    if(submitButtonPrdPage){
        submitButtonPrdPage.click();
        customText.setAttribute('value', "");  
    }else{
        
        let buttonElm = myDivHere.querySelector('.product-form__submit');
        buttonElm.click();
        // submitButtonPrdCard.click();
        customText.setAttribute('value', "");
    }
})


function openNewWindow() {
    var link = 'https://wa.me/+919004485093';
    var newWindow = window.open(link, '_blank');

    if (newWindow) {
        setTimeout(function () {
            newWindow.focus();
        }, 100); // Adjust the delay as needed
    } else {
        alert('Popup blocked! Please allow popups for this site.');
    }
}

// function openNewWindow() {
//     // Replace '123456789' with the desired phone number
//     var phoneNumber = '+919004485093';

//     // Create the WhatsApp Click to Chat link
//     var whatsappLink = 'https://wa.me/' + encodeURIComponent(phoneNumber);

//     // Create an iframe and set its source to the WhatsApp link
//     var iframe = document.createElement('iframe');
//     iframe.src = whatsappLink;
//     iframe.style.width = '80%';
//     iframe.style.height = '400px';

//     // Open the iframe in a modal
//     var modal = document.createElement('div');
//     modal.style.position = 'fixed';
//     modal.style.top = '0';
//     modal.style.left = '0';
//     modal.style.width = '100%';
//     modal.style.height = '100%';
//     modal.style.backgroundColor = 'rgba(0,0,0,0.5)';
//     modal.style.display = 'flex';
//     modal.style.alignItems = 'center';
//     modal.style.justifyContent = 'center';

//     modal.appendChild(iframe);

//     // Append the modal to the body
//     document.body.appendChild(modal);

//         // Close the modal when the iframe is clicked
//         iframe.addEventListener('click', function() {
//         document.body.removeChild(modal);
//     });
// }

const whatsAppPrescBtn = document.getElementById('up-presc--whatsapp');
whatsAppPrescBtn.addEventListener('click', (e) => {
    
    let commonParent = e.target.closest('.up-presc--form');
    // let src = commonParent.querySelector('#presc-img-output img').getAttribute('src');
    // let doc = commonParent.querySelector('#doc-name').value;
    // console.log(src);

    let custLocationId = commonParent.querySelector('#custom-text-location').getAttribute('value');
    // let docLocationId = commonParent.querySelector('#doc-name-location').getAttribute('value');
    // console.log(locationId);

    let customText = document.getElementById(custLocationId);
    customText.setAttribute('value','on WhatsApp');
 
    // console.log(doc);

    // let docName = document.getElementById(docLocationId);
    // docName.setAttribute('value',doc);

    let upPresc = document.getElementById('upload-prescription');
    upPresc.style.display = 'none';

    var submitButtonPrdPage = customText.closest('form').querySelector(" button.product-form__submit");
    var submitButtonPrdCard = customText.closest('form').querySelector(" button.quick-add__submit");
    
    let myDivHere = customText.closest('form').querySelector(".custom-buy-btns");
  console.log(myDivHere,'mydive here 2');
    let qtyToAdd = myDivHere?.getAttribute('qty_to_add');
    // console.log(qtyToAdd,'qtyToAdd');
    if(qtyToAdd){
        let qtyOfPack = qtyToAdd.match(/\d+/)[0];
      if(qtyOfPack){
        const hiddenInputQuantity = myDivHere.querySelector('input[type="hidden"][name="quantity"]');
        
        if (hiddenInputQuantity) {
            hiddenInputQuantity.value = qtyOfPack;
        } else {
            console.log("Input not found.");
        }
      }
    }
    if(submitButtonPrdPage){
        submitButtonPrdPage.click();  
        customText.setAttribute('value', "");
        // openNewWindow();
    }else{
        submitButtonPrdCard.click();
        customText.setAttribute('value', "");
        // openNewWindow();
    }
})

// //Get Cart Data
// var cartData;
// function getCartData() {
//     $.ajax({
//         url: '/cart.js', 
//         type: 'GET',
//         dataType: 'json',
//         success: function(Data) {
//             // console.log('Cart data:', Data);
//             cartData = Data;
//             updateQtySelector(Data);
//             showQtyOnLoad(Data);
//         },
//         error: function(error) {
//             console.error('Error getting cart data:', error);
//         }
//     });
// }
// //Update Qty Selector
// const updateQtySelector = (data) => {
//     const qtySelector = document.querySelectorAll('.d--qty_selector');
//     qtySelector.forEach( elm => {
//         let prodID = elm.getAttribute('data-product-id');
//         data.items.forEach( item => {
//             if( item.variant_id == parseInt(prodID)){
//                 elm.querySelector('.d--qty_cart').setAttribute('value', item.quantity);
//                 // console.log(item.quantity);
//             }else{
//                 // console.log('qty Selector Num Error');
//             }
            
//         })
//     })
// }

// getCartData();  

// const showQty = (elm) => {
//     elm.style.display = 'none';
//     var nextElement = elm.nextElementSibling;
    
//     // console.log(nextElement);
    
//     if (nextElement.classList.contains('d--qty_selector')) {
//         nextElement.style.display = 'flex';
//     }else{
//         var newNxt = elm.closest('product-form').nextElementSibling;
//         // console.log(newNxt);
//         newNxt.style.display = 'flex';
//     }
//     // getCartData();
// }
// const hideQty = (elm) => {
//     elm.style.display = 'none';
//     var prevElement = elm.previousElementSibling;
//     var newPrev = elm.previousElementSibling.querySelector('.ATC_button');
//     if (prevElement.classList.contains('ATC_button')) {
//         prevElement.style.display = 'inline-block';
//     }else{
//         newPrev.style.display = 'inline-block';
//     }
//     // getCartData();
// }

// //Show qty selector onLoad 
// const showQtyOnLoad = (data) => {
//     let atcBtn = document.querySelectorAll('.ATC_button');
//     atcBtn.forEach( (elm) => {
//         let varID = elm.getAttribute('data-var-id');
//         if(varID){
//             // console.log(varID);
//             // console.log(cartData);
//             data.items.forEach( item => {
//                 if(item.variant_id == parseInt(varID)){
//                     showQty(elm);
//                 }
//             })
//         }
//     })
// }

//Add to Cart btn Simulation
// document.addEventListener("click", function(event) {
//     if (event.target.classList.contains("ATC_button")) {
//         var elm = event.target;
//         var commonParent = elm.closest('.product_new_style');
//         // if(commonParent){
//             var submitButton = commonParent.querySelector(".product-form__buttons button.product-form__submit");
//             if (submitButton) {
//                 submitButton.click();
//                 // elm.nextElementSibling.querySelector('.d--qty_cart').setAttribute('value', 1);
//             }
//         // }
//         // else{
//         //     var newNxt = elm.closest('product-form').nextElementSibling;
//         //     // console.log('no product_new_style');
//         //     // console.log(newNxt);
//         //     newNxt.querySelector('.d--qty_cart').setAttribute('value', 1);
//         // }
//         // showQty(elm);
//     }
// });

// //Dynamic Quantity Selector
// const decBtn = document.querySelectorAll('.d--qty_dec');
// const incBtn = document.querySelectorAll('.d--qty_inc');

// //Increment
// incBtn.forEach((element) => {
//     element.addEventListener('click', function(elm) {

//         let prodId = elm.target.closest('.d--qty_selector').getAttribute('data-product-id');
//         let prodLimit = elm.target.closest('.d--qty_selector').getAttribute('data-prod-limit');
//         let getCart = elm.target.closest('.d--qty_selector').querySelector('.d--qty_cart');
//         let dataValue = parseInt(getCart.getAttribute('value'));

//         if(dataValue < prodLimit){
//             let newQty = ++dataValue;
//             getCart.setAttribute('value', newQty);
//             update(prodId,newQty);
//         }        
//     });
// })

// //Decrement
// decBtn.forEach((element) => {
//     element.addEventListener('click', function(elm) {

//         let prodId = elm.target.closest('.d--qty_selector').getAttribute('data-product-id');
//         let getCart = elm.target.closest('.d--qty_selector').querySelector('.d--qty_cart');
//         let dataValue = getCart.getAttribute('value');

//         if(dataValue == 1){
//             hideQty(elm.target.closest('.d--qty_selector'));
//         }

//         if(dataValue >= 1){
//             let newQty = --dataValue;
//             getCart.setAttribute('value', newQty);
//             update(prodId,newQty);
//         }
//     });
// })

// const update = async (prodId, newQty) =>  {
//     const updateData = {
//         quantity: newQty,
//         id: prodId
//     }

//     const req = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(updateData)
//     })
    
//     const res = await req.json();
    
//     if(res){
//         // console.log("done", res);
//     }else{
//         console.log('Error');
//     }
// }    

document.querySelectorAll('.password__show_hide').forEach((passElem)=>{
    passElem.addEventListener('click', function(evt) {
        evt.preventDefault();
        let passInput = passElem.closest('.field').querySelector('input.customerPassword');
        if (passInput.type == "password") {
            passInput.type = "text";
            passElem.querySelector('.custom__eye_off_pass').style.display = "none";
            passElem.querySelector('.custom__eye_on_pass').style.display = "block";
        } else if (passInput.type == "text") {
            passInput.type = "password";
            passElem.querySelector('.custom__eye_off_pass').style.display = "block";
            passElem.querySelector('.custom__eye_on_pass').style.display = "none";
        }
        // console.log(passElem);
        // console.log(passInput.type)
    });
});


let custLoginForm = document.querySelector('.custom__login_form');
let custLoginHeading = document.querySelector('#login');
let customLoginBody = document.querySelector(".customers\\/login");
if (customLoginBody) {
    document.querySelector('.login--recovery_link').addEventListener('click', function() {
        console.log(this);
        // this.closest('.custom__login_form').style.display = "none";
        custLoginForm.style.display = "none";
        custLoginHeading.style.display = "none";
        customLoginBody.style.backgroundColor = "#ffffff"
        
    });
    document.querySelector('.custom__cancel_recover').addEventListener('click', function(){
        console.log(this);
        custLoginForm.style.display = "block";
        custLoginHeading.style.display = "block";
        customLoginBody.style.backgroundColor = "#faa91d"
    });

    if (window.location.hash == '#recover') {
        custLoginForm.style.display = "none";
        custLoginHeading.style.display = "none";
        customLoginBody.style.backgroundColor = "#ffffff"
    }
}

if (document.querySelector('.custom__recover_success_container')) {
    document.addEventListener('click', function(event) {
      // console.log(event);
      if (!document.querySelector('.custom__recover_success_swapper').contains(event.target)) {
        document.querySelector('.custom__recover_success_container').style.display = "none";
      }
    });
    document.querySelector('.custom__popOff').addEventListener('click', function(evt) {
      evt.preventDefault();
      document.querySelector('.custom__recover_success_container').style.display = "none";    
    })
}
// let userLogined = document.querySelector('.user__logined');
// if (userLogined && customLoginBody) {
//     window.location.href = '/account';
// }

$(document).ready(function(){
    $('.custom__change_default_radio').each(function() {
        $(this).on('click', function() {
            $(this).addClass('active');
            $(this).closest('form').trigger('submit');
            // console.log($(this).closest('form'));
        })
    })


});

// if (document.querySelector('.custom__search_design .search__input')) {
//     document.querySelector('.custom__search_design .search__input').addEventListener('keyup', function(evt) {
//         // console.log(this.value.length);
//         if (this.value.length > 0) {
//             this.style.width = '250px';
//             this.style.padding = '15px';
//         } else if(evt.key === "Backspace" || evt.key === "Delete") {
//             // console.log("Bk or Dlt pressed");
//             this.style.width = '50px';
//             this.style.padding = '0';
//         } else {
//             this.style.width = '50px';
//             this.style.padding = '0';
//         }
//     });
//     document.querySelector('.custom__search_design').addEventListener('mouseover', function() {
//         this.classList.add('hoverActive');
//         console.log(this.querySelector('.search__input'));
//         // if (this.value.length < 1) {
//         //     this.style.width = '50px';
//         //     this.style.padding = '0';
//         // }
//     });
//     document.querySelector('.custom__search_design').addEventListener('mouseleave', function() {
//         this.classList.remove('hoverActive');
//         console.log(this.querySelector('.search__input'));
//         // if (this.value.length < 1) {
//         //     this.style.width = '50px';
//         //     this.style.padding = '0';
//         // }
//     });

//     if (window.location.pathname != '/search') {
//         document.querySelector('.custom__search_design .search__input').value = "";
//     } else {
//         let searchInput = document.querySelector('.custom__search_design .search__input');
//         if (searchInput.value.length > 0) {
//             // console.log(searchInput.value.length);
//             searchInput.style.width = '250px';
//             searchInput.style.padding = '15px';
//         }
//     }
// }
document.querySelector('.search__input.field__input').addEventListener('input', function() {
    if (this.value.length > 0) {
        this.closest('.search.search-modal__form').classList.add('overflow-unset');
    } else {
        this.closest('.search.search-modal__form').classList.remove('overflow-unset');
    }
});
document.querySelector('.search__input.field__input').addEventListener('blur', function() {
    if (this.value.length < 1) {
        this.closest('.search.search-modal__form').classList.remove('overflow-unset');
    } else {
        this.closest('.search.search-modal__form').classList.add('overflow-unset');
    }
});

function custom__rebuyWidgetRefresh(){
    setTimeout(() => {
        // console.log('TIMEOUTED');
        if (document.querySelectorAll('.rebuy-button').length > 0) {
            document.querySelectorAll('.rebuy-button')?.forEach((rebutBtn)=>{
                rebutBtn.addEventListener('click', function(evt) {
                    evt.preventDefault();
                    // console.log("Button Clicked", this);
                    setTimeout(() => {
                        // jQuery.getJSON('/cart.js', function (cart) {
                        //     // let cartData = cart.items;
                        //     // console.log(cartData.length);
                        //     if (cart.items.length > 0) {
                        //         // console.log('Cart updated!...');
                        //         fetch(`${routes.cart_url}?section_id=cart-drawer`)
                        //         .then((response) => response.text())
                        //         .then((responseText) => {
                        //             const html = new DOMParser().parseFromString(responseText, 'text/html');
                        //             const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                        //             for (const selector of selectors) {
                        //                 const targetElement = document.querySelector(selector);
                        //                 const sourceElement = html.querySelector(selector);
                        //                 if (targetElement && sourceElement) {
                        //                 targetElement.replaceWith(sourceElement);
                        //                 }
                        //             }
                        //             if (!document.querySelector('cart-drawer.drawer').classList.contains('active')) {
                        //                 document.querySelector('cart-drawer.drawer').classList.add('active');
                        //             }
                        //             custom__rebuyWidgetRefresh();
                        //         });
                        //     }
                        // });
                        
                        fetch(`${routes.cart_url}?section_id=cart-drawer`)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const html = new DOMParser().parseFromString(responseText, 'text/html');
                            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                            for (const selector of selectors) {
                                const targetElement = document.querySelector(selector);
                                const sourceElement = html.querySelector(selector);
                                if (targetElement && sourceElement) {
                                targetElement.replaceWith(sourceElement);
                                }
                            }
                            if (!document.querySelector('cart-drawer.drawer').classList.contains('active')) {
                                document.querySelector('cart-drawer.drawer').classList.add('active');
                                document.querySelector('cart-drawer.drawer').classList.remove('is-empty');
                                document.querySelector('cart-drawer.drawer').querySelector('.drawer__inner-empty').remove();
                                document.querySelector('cart-drawer.drawer').querySelector('cart-drawer-items').classList.remove('is-empty');
                            }
                            custom__rebuyWidgetRefresh();
                        });
                    }, 1500);
                });
            });
        }
    },4000)
    // $('.rebuy-widget .rebuy-product-grid').load(function(){
    // })
}
document.addEventListener('DOMContentLoaded', custom__rebuyWidgetRefresh());

document.querySelector('button.custom__floating_btn')?.addEventListener('click', function() {
    // document.querySelector('.custom__product_ATC_button').dispatchEvent(new Event('click'));
    $('.custom__product_ATC_button').trigger('click');
})

document.addEventListener('DOMContentLoaded',function() {
    // let defQuantitySelector = document.querySelector('.custom__qunatity_selector_meta');
    // defQuantitySelector?.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = defQuantitySelector.value;
    
    document.querySelectorAll('.custom__qunatity_selector_meta')?.forEach((quntitySel)=>{
        quntitySel.addEventListener('change', function(){
            // console.log(this.value);
            this.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = this.value;
            // console.log(this.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]'));
        });
    });

    // onload quantity
    // console.log(document.querySelector('.custom___product_add_to_cart [name="quantity"]').value);
    let custom__quantity_sel =  document.querySelector('input[type="radio"][name="custom__quantity_sel"]:checked');
    let custom__quantity_selBox =  document.querySelector('[name="custom__quantity_sel"]');
    // console.log(custom__quantity_sel.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = custom__quantity_sel.value);
    if (custom__quantity_sel) {
      custom__quantity_sel.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = custom__quantity_sel.value;
    }
    // if (custom__quantity_selBox) {
    //     custom__quantity_selBox.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = custom__quantity_selBox.value;

    // }

    document.querySelectorAll('[name="custom__quantity_sel"]')?.forEach((quantDefVal)=>{
      quantDefVal.addEventListener('change', function() {
        // console.log(this);
        //   quantDefVal.addEventListener('click', function() {
          // console.log(this.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]'));
          // console.log(this.closest('.custom__quantity__meta').querySelectorAll('.option_tagg'));
          this.closest('.custom__quantity__meta').querySelectorAll('.option_tagg').forEach((quanLabels)=>{
              if (quanLabels.classList.contains('custom__quan_sel_active')) {
                quanLabels.classList.remove('custom__quan_sel_active')
                // console.log(quanLabels.classList.remove('custom__quan_sel_active'));
              }
          });
          this.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = this.value;
          this.nextElementSibling.classList.add('custom__quan_sel_active');
        // console.log(quantDefVal.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = quantDefVal.value);
        // quantDefVal.closest('product-info').querySelector('.custom___product_add_to_cart [name="quantity"]').value = quantDefVal.value;
      });
    });

        
    document.querySelectorAll('[name="custom__quantity_sel"]')?.forEach((quanityInput)=>{
        // console.log(quanityInput.value);
        quanityInput.addEventListener('change', function() {
            let currencySign = '₹ ';
            let priceContainer = this.closest('product-info').querySelector('.prod_price_block .custom__product_price__container');
            let proSellingPrice = Number(priceContainer.querySelector('.custom__selling_price_product').dataset.pro_selling_price);
            let proRegularPrice = Number(priceContainer.querySelector('.custom__regular_price_product').dataset.pro_regular_price);
            // console.log(quanityInput.closest('product-info').querySelector('.prod_price_block .custom__product_price__container .custom__selling_price_product').dataset.pro_selling_price);
            // console.log(quanityInput.closest('product-info').querySelector('.prod_price_block .custom__product_price__container .custom__regular_price_product').dataset.pro_regular_price);
            if (proSellingPrice != NaN) {
                let newSellingPrice = proSellingPrice * this.value;
                // let newSellingPrice = proSellingPrice * this.value / 100;
                if (proSellingPrice > 0 && proRegularPrice > 0) {
                    priceContainer.querySelector('.price__sale .custom__selling_price_product').innerHTML = currencySign.concat(newSellingPrice.toLocaleString());
                    // console.log("newSellingPrice : ", newSellingPrice)
                } else {
                    priceContainer.querySelector('.custom__selling_price_product').innerHTML = currencySign.concat(newSellingPrice.toLocaleString());
                    // console.log("newSellingPrice : ", newSellingPrice)
                }
            }
            if (proRegularPrice != NaN) {
                let newRegularPrice = proRegularPrice * this.value;
                priceContainer.querySelector('.custom__regular_price_product').innerHTML = currencySign.concat(newRegularPrice.toLocaleString());
                // console.log("newRegularPrice : ", newRegularPrice)
            }

            // console.log("custom__selling_price_product : ", priceContainer.querySelector('.custom__selling_price_product').dataset)
            // console.log("custom__regular_price_product : ", priceContainer.querySelector('.custom__regular_price_product').dataset)

            // if (proSellingPrice != '') {
            //     priceContainer.querySelector('.custom__selling_price_product').innerHTML = currencySign.concat(newSellingPrice.toLocaleString());
            // }
            // if (proRegularPrice != '') {
            //     priceContainer.querySelector('.custom__regular_price_product').innerHTML = currencySign.concat(newRegularPrice.toLocaleString());
            // }
            
            // console.log(priceContainer.querySelector('.custom__selling_price_product'));
            // console.log(currencySign.concat(newSellingPrice.toLocaleString()));
            // console.log(currencySign.concat(newRegularPrice.toLocaleString()));
            // console.log(this.value)
        });
    });


    // Floating btn
    var addToCartContainer = document.querySelector(".custom__floating_elem");
    if (addToCartContainer) {
      var header = document.querySelector("sticky-header.header-wrapper");
      var breadcrumb = document.querySelector(".custom__breadcrumb_top")?.offsetHeight;
      if(breadcrumb){
        var product_media = document.querySelector(".grid__item.product_new_style_gallery.product__media-wrapper").offsetHeight;
        var total = breadcrumb + product_media;
        //   console.log(header.offsetTop + header.offsetHeight + total);
        window.addEventListener("scroll", function () {
            var triggerHeight = header.offsetTop + header.offsetHeight + total + 30;
            var scrollPosition = window.scrollY;
        
            if (scrollPosition > triggerHeight) {
            addToCartContainer.classList.add("floatingBtnShow");
            } else {
            addToCartContainer.classList.remove("floatingBtnShow");
            }
        });
      }
    }

    // get wishlist products


        const customerId = document.getElementById('cutomer-data-info-card')?.value
        if (customerId){
        
        fetch(`https://nodejs.animeal.in/api/get-wishlist?customer_id=${customerId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json', // Send as JSON
            }   
          })
          .then(response => response.json()) // Parse the response as JSON
          .then(data => {
            //   console.log('wishlist api response data: ', data)
            // Check if the API response is successful
            if (data.success) {
                
                // console.log('wishlist products: ', data.wishlist)
                const allHeartSvg = document.querySelectorAll('.heart-svg')
                allHeartSvg.forEach((heartSvg)=>{
                    const productId = heartSvg.getAttribute('data-product-handle');
                    const svgPath = heartSvg.querySelector('svg path');
                    if(data.wishlist.includes(productId)){            
                        svgPath.setAttribute('stroke', 'red'); 
                        svgPath.setAttribute('fill', 'red'); 
                    }
                    else{         
                        svgPath.setAttribute('stroke', 'grey'); 
                        svgPath.setAttribute('fill', 'none'); 
            
                    }
                })
      
              
       
            } else {
              console.log('Error: Unable to add to wishlist');
            }
          })
          .catch(error => {
            console.error('Error:', error); // Handle any errors
          });


    
        // Get the dynamic data from the element's attributes
       // Getting the customer ID
    
        
    
        // Perform the API call using fetch
        
           
        }
    //   getting wishlist product end here

    document.querySelectorAll('.card-wrapper').forEach(wrapper => {
        const images = wrapper.querySelectorAll('img');
        if (images.length > 1) {
            wrapper.classList.add('has-multiple-images');
        }
    });


});

function custom__range_price_slider() {
    
  var thumbsize = 14;

  function draw(slider,splitvalue) {

      /* set function vars */
      // var min = slider.querySelector('.min');
      // var max = slider.querySelector('.max');
      var min = slider.querySelector('.min');
      var max = slider.querySelector('.max');
      var lower = slider.querySelector('.lower');
      var upper = slider.querySelector('.upper');
      // var legend = slider.querySelector('.legend');
      var thumbsize = parseInt(slider.getAttribute('data-thumbsize'));
      var rangewidth = parseInt(slider.getAttribute('data-rangewidth'));
      var rangemin = parseInt(slider.getAttribute('data-rangemin'));
      var rangemax = parseInt(slider.getAttribute('data-rangemax'));

      /* set min and max attributes */
      min.setAttribute('max',splitvalue);
      max.setAttribute('min',splitvalue);

      /* set css */
      min.style.width = parseInt(thumbsize + ((splitvalue - rangemin)/(rangemax - rangemin))*(rangewidth - (2*thumbsize)))+'px';
      max.style.width = parseInt(thumbsize + ((rangemax - splitvalue)/(rangemax - rangemin))*(rangewidth - (2*thumbsize)))+'px';
      min.style.left = '0px';
      max.style.left = parseInt(min.style.width)+'px';
      min.style.top = lower.offsetHeight+'px';
      max.style.top = lower.offsetHeight+'px';
      // legend.style.marginTop = min.offsetHeight+'px';
      slider.style.height = (lower.offsetHeight + min.offsetHeight)+'px';
      
      /* correct for 1 off at the end */
      if(max.value>(rangemax - 1)) max.setAttribute('data-value',rangemax);

      /* write value and labels */
      max.value = max.getAttribute('data-value'); 
      min.value = min.getAttribute('data-value');
      lower.innerHTML = min.getAttribute('data-value');
      upper.innerHTML = max.getAttribute('data-value');

  }

  function init(slider) {
      /* set function vars */
      var min = slider.querySelector('.min');
      var max = slider.querySelector('.max');
      var rangemin = parseInt(min.getAttribute('min'));
      var rangemax = parseInt(max.getAttribute('max'));
      var avgvalue = (rangemin + rangemax)/2;
      var legendnum = slider.getAttribute('data-legendnum');

      /* set data-values */
      min.setAttribute('data-value',rangemin);
      max.setAttribute('data-value',rangemax);
      
      /* set data vars */
      slider.setAttribute('data-rangemin',rangemin); 
      slider.setAttribute('data-rangemax',rangemax); 
      slider.setAttribute('data-thumbsize',thumbsize); 
      slider.setAttribute('data-rangewidth',slider.offsetWidth);

      /* write labels */
      var lower = document.createElement('span');
      var upper = document.createElement('span');
      lower.classList.add('lower','value');
      upper.classList.add('upper','value');
      lower.appendChild(document.createTextNode(rangemin));
      upper.appendChild(document.createTextNode(rangemax));
      slider.insertBefore(lower,min.previousElementSibling);
      slider.insertBefore(upper,min.previousElementSibling);
      
      /* write legend */
      // var legend = document.createElement('div');
      // legend.classList.add('legend');
      // var legendvalues = [];
      // for (var i = 0; i < legendnum; i++) {
      //     legendvalues[i] = document.createElement('div');
      //     var val = Math.round(rangemin+(i/(legendnum-1))*(rangemax - rangemin));
      //     legendvalues[i].appendChild(document.createTextNode(val));
      //     legend.appendChild(legendvalues[i]);

      // } 
      // slider.appendChild(legend);

      /* draw */
      draw(slider,avgvalue);

      /* events */
      min.addEventListener("input", function() {update(min);});
      max.addEventListener("input", function() {update(max);});
  }

  function update(el){
      /* set function vars */
      var slider = el.parentElement;
      var min = slider.querySelector('#min');
      var max = slider.querySelector('#max');
      var minvalue = Math.floor(min.value);
      var maxvalue = Math.floor(max.value);
      
      /* set inactive values before draw */
      min.setAttribute('data-value',minvalue);
      max.setAttribute('data-value',maxvalue);

      var avgvalue = (minvalue + maxvalue)/2;

      /* draw */
      draw(slider,avgvalue);
  }

  var sliders = document.querySelectorAll('.min-max-slider');
  sliders.forEach( function(slider) {
      init(slider);
  });

}
// custom__range_price_slider();



document.querySelectorAll('.frcp-nav-button[role="link"]')?.forEach((menuTabBtn)=>{
    menuTabBtn.addEventListener('click', function() {
        // console.log(this);
        // Scroll to the element with the id 'targetElement'
        this.closest('.frcp-main').querySelector('.frcp-nav-button[aria-label="Logout"]').scrollIntoView({
            behavior: 'smooth'
        })
    });
});

function custRemovePouchItems() {
    document.querySelectorAll('.custom__cart_item_remove')?.forEach((custRemoveBtn)=>{
        custRemoveBtn.addEventListener('click', function() {
            this.closest('.cart-item').querySelector('cart-remove-button').click();
            // console.log(this.closest('.cart-item').querySelector('cart-remove-button'));
            custRemovePouchItems();
        });
    });
}
custRemovePouchItems();

// let observer = new MutationObserver((data)=>{
//   // console.log(data);
//   data.forEach((mutaion)=>{
//     // console.log(mutaion);
//     // console.log(mutaion.addedNodes);
//     if(mutaion.addedNodes.length > 0) {
//       // let min__filter_val = document.querySelector('.custom__range_slider-input [name="filter.v.price.gte"]');
//       // let max__filter_val = document.querySelector('.custom__range_slider-input [name="filter.v.price.lte"]');
//       // min__filter_val.value = min__filter_val.min;
//       // max__filter_val.value = max__filter_val.max;
//     }
//     mutaion.removedNodes.forEach((removedElem)=>{
//       console.log(removedElem.classList); 
//       if (removedElem.classList == 'filter__active_price') {
//         // console.log(window.location.href);
//         if (!window.location.href.includes('filter.v.price.gte') || !window.location.href.includes('filter.v.price.gte')) {
//           // console.log('Price Filters not presented');
//             //   let min__filter_val = document.querySelector('.custom__range_slider-input [name="filter.v.price.gte"]');
//             //   let max__filter_val = document.querySelector('.custom__range_slider-input [name="filter.v.price.lte"]');
//             //   min__filter_val.value = min__filter_val.min;
//             //   min__filter_val.style.width= '125px';
//             //   min__filter_val.style.left= 0;
//             //   max__filter_val.value = max__filter_val.max;
//             //   max__filter_val.style.width= '125px';
//             //   max__filter_val.style.left= '125px';
//             console.log("HJHJHJHJHJHJHJHJH");
//             // console.log(removedElem);
//             // custom__range_price_slider();
//         }
//       } else {
//         // console.log(window.location.href);
//       }
//     });
//   });
// });

// // document.querySelectorAll('.active-facets').forEach((activeElem)=>{
// document.querySelectorAll('facet-filters-form form, .active-facets').forEach((activeElem)=>{
//   observer.observe(activeElem, {
//       childList : true,
//       attributes: true,
//       subtree: true,
//   });
//   // console.log(activeElem.querySelector('facet-remove.filter__active_price'));
// });
// document.querySelectorAll('.active-facets').forEach((activeElem)=>{
//   observer.observe(activeElem, {
//       childList : true,
//       attributes: true,
//       subtree: true,
//   });
//   // console.log(activeElem.querySelector('facet-remove.filter__active_price'));
// });

// window.onload = function() {
//   console.clear();
// }

// if (document.querySelector('.template-collection')) {
if (document.querySelector('.custom__price_range_filter')) {
    function custom_price_filter() {
      let rangeInput = document.querySelectorAll(".range-input input"),
          range = document.querySelector(".slider .progress");
      let priceInput = document.querySelectorAll(".price-input input");
      let priceGap = 10;
        //   let priceGap = 1;
    
      priceInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          let minPrice = parseInt(priceInput[0].value),
            maxPrice = parseInt(priceInput[1].value);
    
          if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
            if (e.target.className === "input-min") {
              rangeInput[0].value = minPrice;
              range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
            } else {
              rangeInput[1].value = maxPrice;
              range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
            }
          }
        });
      });
    
      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          let minVal = parseInt(rangeInput[0].value),
            maxVal = parseInt(rangeInput[1].value);
    
          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
            range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
          }
        });
      });
    
    
      // initialize the range min-max inputs
      let min__range_input = document.querySelector('.custom__price_filter_desktop .range-min.filter_v_price_gte');
      let max__range_input = document.querySelector('.custom__price_filter_desktop .range-max.filter_v_price_lte');
      let min__range_input_mobile = document.querySelector('.custom__price_filter_mobile .range-min.filter_v_price_gte');
      let max__range_input_mobile = document.querySelector('.custom__price_filter_mobile .range-max.filter_v_price_lte');
    
      // initialize the range min-max inputs
    //   let min__number_input = document.querySelector('.custom__price_filter_desktop .input-min[type="number"]');
      let min__number_input = document.querySelector('.custom__price_filter_desktop .input-min');
    //   let max__number_input = document.querySelector('.custom__price_filter_desktop .input-max[type="number"]');
      let max__number_input = document.querySelector('.custom__price_filter_desktop .input-max');
    //   let min__number_input_mobile = document.querySelector('.custom__price_filter_mobile .input-min[type="number"]');
      let min__number_input_mobile = document.querySelector('.custom__price_filter_mobile .input-min');
    //   let max__number_input_mobile = document.querySelector('.custom__price_filter_mobile .input-max[type="number"]');
      let max__number_input_mobile = document.querySelector('.custom__price_filter_mobile .input-max');
    
      function filterDefaultVal(){
        let urlObj = new URL(window.location.href);
        // console.log(urlObj.href);
        // console.log(urlObj.searchParams.has('filter.v.price.gte'));
        if(!urlObj.searchParams.has('filter.v.price.gte') || !urlObj.searchParams.has('filter.v.price.lte')){
          // set range value based on min-max when no filters active
        //   console.log(min__range_input.dataset.value_set);
          min__range_input.value = min__range_input.getAttribute('min');
          max__range_input.value = max__range_input.getAttribute('max');
          min__number_input.value = min__number_input.getAttribute('min');
          max__number_input.value = max__number_input.getAttribute('max');
          min__range_input_mobile.value = min__range_input_mobile.getAttribute('min');
          max__range_input_mobile.value = max__range_input_mobile.getAttribute('max');
          min__number_input_mobile.value = min__number_input_mobile.getAttribute('min');
          max__number_input_mobile.value = max__number_input_mobile.getAttribute('max');
        } else {
          // console.log(window.location.href);
        }
      }
      // document.querySelectorAll('facet-remove').forEach((removeFilter)=>{
      //     removeFilter.addEventListener('click', filterDefaultVal());
      //     // console.log(removeFilter);
      // });
      
    // window.onload = filterDefaultVal();
    filterDefaultVal();
    
    let currencySignFilter = '₹';
      // Change the input value when range min is changed
      min__range_input.addEventListener('change', function() {
          min__number_input.value = min__range_input.value;
          max__number_input.value = max__range_input.value;
          // console.log(this.value);
      });
      // Change the input value when range min is changed
      max__range_input.addEventListener('change', function() {
          min__number_input.value = min__range_input.value;
          max__number_input.value = max__range_input.value;
          // console.log(this.value);
      });
    
      // Change the input value when min number input is changed
      min__number_input.addEventListener('change', function() {
        min__range_input.value = min__number_input.value;
          // console.log(this.value);
      });
      // Change the input value when max number input is changed
      max__number_input.addEventListener('change', function() {
        max__range_input.value = max__number_input.value;
          // console.log(this.value);
      });
    
      // Mobile Filters
      // Change the input value when range min is changed
      min__range_input_mobile.addEventListener('touchmove', function() {
          min__number_input_mobile.value = min__range_input_mobile.value;
          max__number_input_mobile.value = max__range_input_mobile.value;
          // console.log(this.value);
      });
      // Change the input value when range min is changed
      max__range_input_mobile.addEventListener('touchmove', function() {
          min__number_input_mobile.value = min__range_input_mobile.value;
          max__number_input_mobile.value = max__range_input_mobile.value;
          // console.log(this.value);
      });
    
      // Change the input value when min number input is changed
      min__number_input_mobile.addEventListener('change', function() {
        min__range_input_mobile.value = min__number_input_mobile.value;
          // console.log(this.value);
      });
      // Change the input value when max number input is changed
      max__number_input_mobile.addEventListener('change', function() {
        max__range_input_mobile.value = max__number_input_mobile.value;
          // console.log(this.value);
      });
    }
    custom_price_filter();
    
    let observer = new MutationObserver((data)=>{
      // console.log(data);
      data.forEach((mutaion)=>{
        // console.log(mutaion);
        // console.log(mutaion.addedNodes);
        // if(mutaion.addedNodes.length > 0) {
        //   variantsAddToCart();
        // }
        mutaion.removedNodes.forEach((removedElem)=>{
          // console.log(removedElem);
          if (removedElem.classList == 'filter__active_price' || removedElem.classList == 'facet-filters__field') {
            // console.log(window.location.href);
            if (!window.location.href.includes('filter.v.price.gte') || !window.location.href.includes('filter.v.price.gte')) {
              // console.log('Price Filters not presented');
              custom_price_filter();
            //   variantsAddToCart();
            }
          } else {
            // console.log(window.location.href);
          }
        });
      });
    });
    
    // document.querySelectorAll('.active-facets').forEach((activeElem)=>{
    document.querySelectorAll('facet-filters-form form, .active-facets').forEach((activeElem)=>{
      observer.observe(activeElem, {
          childList : true,
          attributes: true,
          subtree: true,
      });
      // console.log(activeElem.querySelector('facet-remove.filter__active_price'));
    });
    document.querySelectorAll('.active-facets').forEach((activeElem)=>{
      observer.observe(activeElem, {
          childList : true,
          attributes: true,
          subtree: true,
      });
      // console.log(activeElem.querySelector('facet-remove.filter__active_price'));
    });
}

// function openInIframe(event) {
//     event.preventDefault(); // Prevent the default anchor behavior
//     const iframe = document.getElementById('whatsapp-iframe');
//     const url = "https://api.whatsapp.com/send/?phone=%2B919004157093&text&type=phone_number&app_absent=0"; // Replace with your URL
//     iframe.src = url; // Set the iframe source
//     iframe.style.display = "block"; // Make the iframe visible
// }

const chooseFile = document.getElementById('custom_upload_choose_file');
if(chooseFile){
    chooseFile.addEventListener('click', (e)=>{
        e.preventDefault();
        const customUpPreSec = document.querySelector('.custom_upload-prescription-section')
        const custPreImgUpInp = customUpPreSec.querySelector('#cust_presc-img-upload');
        custPreImgUpInp.click();
    })
}

const chooseUploadFile = document.getElementById('upload_choose_file');
if(chooseUploadFile){
    chooseUploadFile.addEventListener('click', (e)=>{
        e.preventDefault();
        const customUpPreSec = document.querySelector('.upload-prescription-section')
        const custPreImgUpInp = customUpPreSec.querySelector('#presc-img-upload');
        custPreImgUpInp.click();
    })
}

const chooseUploadFileSec = document.getElementById('upload_choose_file-sec');
if(chooseUploadFileSec){
    chooseUploadFileSec.addEventListener('click', (e)=>{
        e.preventDefault();
        const customUpPreSec = document.querySelector('#upload-prescription_sec')
        const custPreImgUpInp = customUpPreSec.querySelector('#presc-img-upload-sec');
        custPreImgUpInp.click();
    })
}


  function addToWishlistHandler(event, customerId) {
    const heartSvg = event.currentTarget;

    // Get the dynamic data from the element's attributes
    const productId = heartSvg.getAttribute('data-product-handle'); // Getting the product handle
    // const customerId = document.getElementById('cutomer-data-info-card')?.value // Getting the customer ID

    

    // Perform the API call using fetch
    fetch('https://nodejs.animeal.in/api/update-wishlist', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // Send as JSON
      },
      body:JSON.stringify({
        customer_id: customerId,
        product_id: productId,
        // type: 'update-wishlist'
      })
    })
    .then(response => response.json()) // Parse the response as JSON
    .then(data => {
        // console.log('wishlist api response data: ', data)
      // Check if the API response is successful
      if (data.success) {

        // console.log('wishlist products: ', data.wishlist)
        const svgPath = heartSvg.querySelector('svg path');
        if(data.wishlist.includes(productId)){            
            svgPath.setAttribute('stroke', 'red'); 
            svgPath.setAttribute('fill', 'red'); 
        }
        else{         
            svgPath.setAttribute('stroke', 'grey'); 
            svgPath.setAttribute('fill', 'none'); 

        }
 
      } else {
        // console.log('Error: Unable to add to wishlist');
      }
    })
    .catch(error => {
    //   console.error('Error:', error); // Handle any errors
    });
  }

function getSelectedInterests() {
    const selectedInterests = [];
    document.querySelectorAll('input[name="interest"]:checked').forEach((checkbox) => {
      selectedInterests.push(checkbox.value);
    });
    return selectedInterests;
  }

 async function shoppingInterestHandler(checkbox, customerId) {
   
      const selectedInterests = getSelectedInterests();
    //   console.log('input checkbox change handler', selectedInterests, customerId,'cus id')
      // Send the selected interests to the backend
      try {
        const response = await fetch('https://nodejs.animeal.in/api/update-shopping-interest', { 
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({shopping_interest : selectedInterests, customer_id: customerId}), 
        });

        const result = await response.json();
        if (result.success) {
        //   console.log('Metafield updated successfully');
        } else {
        //   console.error('Error updating metafield', result.message);
        }
      } catch (error) {
        // console.error('Request failed:', error);
      }
 }


 function AddWishlistProductToCart(e) {
    const variantId = e.getAttribute('data-variant-id');
    const qty = e.getAttribute('data-total-quantity');
    // console.log("Variant ID:", variantId);

    const item = {
        id: variantId,
        quantity: qty? qty: 1
    };

    // Make an AJAX request to add the item to the cart
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: [item] }) // Ensure the items array is wrapped properly
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add product to cart');
        }
        return response.json();
    })
    .then(cart => {
        const drawer = document.querySelector('.drawer');
                
        if (drawer.classList.contains('active')) {
        } else {
        drawer.classList.remove("is-empty")
        drawer.classList.add("active")
        const body_overflow = document.querySelector('body');
        body_overflow.classList.add('overflow-hidden');
        }

        $('.drawer').load(location.href + ' #CartDrawer');

        $('#cart-icon-bubble').load(location.href + ' #cart-icon-bubble');
    
    })
    .catch(error => {
        // console.error('Error adding item to cart:', error);
        alert('An error occurred while adding the item to the cart.');
    });
}


// for animeal vet app usage(using website local storage for doctorId)
function saveDoctorId(){
    const url = new URL(window.location.href);
        const encryptedData = url.searchParams.get('doctor_id');
     if(!encryptedData){
       return;
     }

const secretKey = CryptoJS.SHA256("your-secret-passphrase"); // Generates 32-byte key

function decryptData(encryptedData) {
    const ivHex = encryptedData.slice(0, 32); // Extract IV (first 16 bytes in hex)
    const encryptedHex = encryptedData?.slice(32); // Remaining is encrypted data

    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        secretKey,
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    return decrypted?.toString(CryptoJS.enc.Utf8);
}

// Example usage:
// const encryptedData = "paste-your-encrypted-data-here"; // Received from backend
// console.log("Decrypted:", decryptData(encryptedData));
  const decryptedData = decryptData(encryptedData);
  if(decryptedData){
    localStorage.setItem('doctor_id', decryptedData);
  }
}
saveDoctorId();








